export const typesCRReview = {
    GET_CRREVIEW_SUCCESS:'GET_CRREVIEW_SUCCESS',
    GET_CRREVIEW_ERROR:'GET_CRREVIEW_ERROR',
    GET_CRREVIEW_BEGIN:'GET_CRREVIEW_BEGIN',
    CRCREATE_ADDRESS: 'CRRESERVATIONS_PRIMARY_ADDRESS',

    CRRESERVATIONS_PRIMARY_ADDRESS:'CRRESERVATIONS_PRIMARY_ADDRESS',

    GET_CRPRICEANDTAX_SUCCESS:'GET_CRPRICEANDTAX_SUCCESS',
    GET_CRPRICEANDTAX_ERROR:'GET_CRPRICEANDTAX_ERROR',
    GET_CRPRICEANDTAX_BEGIN:'GET_CRPRICEANDTAX_BEGIN',
    RESET_CRPRICEANDTAX_INIT: 'RESET_CRPRICEANDTAX_INIT'
}
